// ABOUTME: Banner shown on HomePage when the workspace is using a demo/sample data source.
// ABOUTME: Prompts user to connect their own Databricks with a dismissible CTA.

import { useNavigate } from 'react-router-dom';
import { Database, X } from 'lucide-react';

interface DemoBannerProps {
  dataSourceName: string;
  onDismiss: () => void;
  dismissed?: boolean;
}

export function DemoBanner({ dataSourceName, onDismiss, dismissed = false }: DemoBannerProps) {
  const navigate = useNavigate();

  if (dismissed) {
    return null;
  }

  return (
    <div className="mb-6 px-4 py-3 rounded-sm bg-primary-50 border border-primary-200 flex items-center justify-between gap-4">
      <div className="flex items-center gap-3">
        <Database className="w-5 h-5 text-primary-500 flex-shrink-0" />
        <p className="text-sm text-surface-700">
          You're exploring with sample data
          {dataSourceName && (
            <span className="font-medium"> ({dataSourceName.replace('Sample: ', '')})</span>
          )}
          .
        </p>
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        <button
          onClick={() => navigate('/onboarding?step=data-source')}
          className="text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
        >
          Connect your own data
        </button>
        <button
          onClick={onDismiss}
          className="p-1 text-surface-400 hover:text-surface-600 transition-colors"
          aria-label="Dismiss demo banner"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
